import { useEffect, useRef, useId } from 'react';
import { enqueueAdLoad } from '@/lib/adQueue';

type AdScriptBannerProps = {
  atKey: string;
  width: number;
  height: number;
  scriptSrc: string;
};

export const AdScriptBanner = ({ atKey, width, height, scriptSrc }: AdScriptBannerProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const uniqueId = useId();
  const loadedRef = useRef(false);

  useEffect(() => {
    if (!containerRef.current || loadedRef.current) return;
    loadedRef.current = true;

    const container = containerRef.current;

    // Use the queue to ensure ads load sequentially
    enqueueAdLoad(() => {
      return new Promise<void>((resolve) => {
        // Create a unique container for this ad
        const adContainer = document.createElement('div');
        adContainer.id = `ad-container-${uniqueId.replace(/:/g, '')}`;
        container.appendChild(adContainer);

        // Set atOptions before loading the script
        (window as any).atOptions = {
          key: atKey,
          format: 'iframe',
          height: height,
          width: width,
          params: {},
        };

        // Create and append the script
        const script = document.createElement('script');
        script.src = scriptSrc;
        script.async = true;
        script.setAttribute('data-cfasync', 'false');
        
        script.onload = () => {
          // Give the ad network time to process atOptions
          setTimeout(resolve, 500);
        };
        script.onerror = () => resolve();
        
        adContainer.appendChild(script);
      });
    });
  }, [atKey, width, height, scriptSrc, uniqueId]);

  return (
    <div 
      ref={containerRef}
      className="flex items-center justify-center"
      style={{ minWidth: width, minHeight: height }}
    />
  );
};
